import SelectTypeField from './SelectTypeField';

export default SelectTypeField;



// WEBPACK FOOTER //
// ./src/views/components/SelectTypeField/index.js